import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  DeleteButton,
  TextInput,
  SelectInput,
  ReferenceInput,
  FunctionField,
  useGetOne,
  useRecordContext,
} from 'react-admin';
import { ChipList, ListActions } from '../common';
import { User } from '../../types';

const GroupChipField = () => {
  const record = useRecordContext<User>();
  const { data: group, isLoading } = useGetOne(
    'groups',
    { id: record?.groupId || 0 },
    { enabled: !!record?.groupId }
  );

  if (!record?.groupId) {
    return <ChipList items={[]} emptyText="No Group" emptyColor="default" />;
  }

  if (isLoading) {
    return <ChipList items={[]} loading={true} />;
  }

  return (
    <ChipList
      items={[
        {
          id: group?.id || 0,
          label: group?.name || 'Unknown',
          to: `/groups/${group?.id}/show`,
        },
      ]}
    />
  );
};

const UserFilters = [
  <TextInput key="username" label="Username" source="username" alwaysOn />,
  <SelectInput
    key="role"
    label="Role"
    source="role"
    choices={[
      { id: 'Admin', name: 'Admin' },
      { id: 'Partner', name: 'Partner' },
    ]}
    alwaysOn
  />,
  <ReferenceInput key="groupId" label="Group" source="groupId" reference="groups" alwaysOn>
    <SelectInput optionText="name" />
  </ReferenceInput>,
];

export const UserList = () => (
  <List filters={UserFilters} actions={<ListActions />} sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="username" />
      <TextField source="role" />
      <FunctionField label="Group" render={() => <GroupChipField />} sortBy="groupId" />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
